// extracted by mini-css-extract-plugin
module.exports = {"card":"d_g","red":"d_h","blue":"d_j","green":"d_k","yellow":"d_l","orange":"d_m","violet":"d_n","title":"d_p"};